<div *ngIf="form; else loading">
  <form [formGroup]="form">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xs-6 col-md-6 form-group">
          <strong id="taskUpsertTitle">{{ strMode | translate }} {{ 'task' | translate }}</strong>
        </div>
      </div>
      <div class="row">
        <div *ngFor="let data of fields" class="col-{{data.space}} mb-3">
          <ng-container>
            <app-edit-field [item]="data" [form]="form" [bSubmitted]="bSubmitted" [strMode]="strMode"
              [strModule]="strModule"></app-edit-field>
          </ng-container>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-6 col-md-6">
          <button id="taskUpsertCancel" type="button" class="btn btn-warning btn-block btn-lg" (click)="cancel()" [disabled]="bSaving">
            <strong>{{ 'cancel' | translate }}</strong>
          </button>
        </div>
        <div class="col-xs-6 col-md-6">
          <button id="taskUpsertSave" type="button" class="btn btn-primary btn-block btn-lg" (click)="save()" [disabled]="bSaving">
            <strong><fa-icon *ngIf="bSaving" [icon]="['fas', 'spinner']" [spin]="true" aria-hidden="true"></fa-icon> {{ 'save' | translate }}</strong>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
<ng-template #loading>
  <span class="no-content text-center">
    <inline-view-loader [isLoading]="true"></inline-view-loader>
  </span>
</ng-template>